

export const helpText = () => {

  document.addEventListener("mouseover", function(e){
    if(e.target && e.target.className.length > 0) {
      if ( e.target.className.indexOf("js-help-text") > -1 ) {
        e.target.closest(".card").style.zIndex = '29';
        let screen = window.innerWidth;
        let left = e.target.getBoundingClientRect().left;
        let offset = +screen - +left - 170;
        e.target.querySelector("span").classList.add("card__fly_show");
        if ( document.querySelector(".modal_open") ){
          offset = (+screen - +document.querySelector(".modal_open .modal__inner").offsetWidth) / 2 + +document.querySelector(".modal_open .modal__inner").offsetWidth - +left - 100;
        }
        if ( offset < 10 ) {
          e.target.querySelector("span").classList.add("card__fly_right");
        }
      }
    }
  });

  document.addEventListener("mouseout", function(e){
    if(e.target && e.target.className.length > 0) {
      if(e.target && e.target.className.indexOf("js-help-text") > -1) {
        e.target.closest(".card").style.zIndex = '1';
        e.target.querySelector("span").classList.remove("card__fly_show");
        setTimeout(() => {
          e.target.querySelector("span").classList.remove("card__fly_right");
        }, 150);
      }
    }
  });

}